var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{ref:"editor",staticClass:"h-100",attrs:{"type":_vm.type,"config":_vm.configuration},on:{"blur":function($event){return _vm.$emit('blur', $event)}},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }